define('BackInStockNotification.Helper', [
    'jQuery',
    'underscore',
    'Utils'
], function BackInStockNotificationHelper(
    jQuery,
    _
) {
    'use strict';

    var BackInStockNotificationHelper = {
        addToNavigtion: function addToNavigation() {
            var target;
            var backInStockSubscriptionContainer = '#backInStockSubscription';
            var html = '<li>' +
                            '<a class="header-menu-myaccount-anchor-level3"' +
                            'id="backInStockSubscription"' +
                            'href="#" data-touchpoint="customercenter"' +
                            'data-hashtag="#backinstocknotification" name="backinstocknotification">' +
                            _.translate('Back In Stock Subscriptions') +
                            '</a>' +
                        '</li>';

            _.delay(function(){
                target = jQuery('a[name=settings]').next('.header-menu-myaccount-level3');

                if(!jQuery(backInStockSubscriptionContainer).length) {
                    target.append(html);
                }
            }, 2000);
        }
    };

    return BackInStockNotificationHelper;
});
